import * as React from "react"

// <script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';}(jQuery));var $mcj = jQuery.noConflict(true);</script>

const Newsletter = () => {
 return (
   <div>
    <link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css" />

    <div id="mc_embed_signup">
      <form action="https://totalwebconnections.us13.list-manage.com/subscribe/post?u=1a5499afe0da31703021a1059&amp;id=fc74337b5d" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
       <div id="mc_embed_signup_scroll">
        <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
        <div class="mc-field-group">
          <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
          </label>
          <input type="email" name="EMAIL" class="required email" id="mce-EMAIL" />
        </div>
        <div class="mc-field-group">
          <label for="mce-FNAME">First Name </label>
          <input type="text" name="FNAME" class="" id="mce-FNAME" />
          </div>
        <div class="mc-field-group">
          <label for="mce-LNAME">Last Name </label>
          <input type="text" name="LNAME" class="" id="mce-LNAME" />
        </div>
         <div id="mce-responses" class="clear">
           <div class="response" id="mce-error-response" style={{display: "none"}}></div>
           <div class="response" id="mce-success-response" style={{display: "none"}}></div>
         </div>
         <div style={{position: "absolute", left: "-5000px"}} aria-hidden="true"><input type="text" name="b_1a5499afe0da31703021a1059_fc74337b5d" tabindex="-1" value="" /></div>
         <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button" /></div>
        </div>
      </form>
    </div>
   </div>
 )
}


export default Newsletter
